UAEditAccountCtrl.$inject = ['userAccount', 'adminApi', 'contentProfiles', '$uibModalInstance']

export default function UAEditAccountCtrl(
  userAccount,
  adminApi,
  contentProfileStore,
  $modalInstance
) {
  this.account = userAccount

  this.showError = false
  this.errorMessage = ''
  this.saving = false
  this.contentProfiles = []
  this.idpList = []
  this.ssoConfig = {}

  this.clearSsoProviders = function() {
    this.account.sso_provider_ids = []
  }

  this.$onInit = function() {
    this.ssoConfig.option =
      this.account.sso_provider_ids &&
      this.account.sso_provider_ids.length > 0
        ? 'assign'
        : 'none'
    contentProfileStore.getContentProfiles().then(profiles => {
      this.contentProfiles = profiles
    })
    adminApi.getIdentityProvidersList().then(idps => {
      this.idpList = idps
    })
  }

  this.save = function() {
    this.saving = true
    adminApi
      .editAccount(this.account.uuid, this.account)
      .then(
        function(resp) {
          this.showError = false
          $modalInstance.close(resp)
        }.bind(this),
        function(resp) {
          this.showError = true
          this.errorMessage = resp
        }.bind(this)
      )
      .finally(
        function() {
          this.saving = false
        }.bind(this)
      )
  }
}
